import React from "react"
import { ModalSkeleton } from "../../common/modals/ModalSkeleton"
import { BulletTextM } from "../../common/components/text/BulletTextM"
import { ModalCardSkeleton } from "../../common/modals/ModalCardSkeleton"

export const SchoolAssessmentDetailModal = ({
    title,
    visible,
    onClose,
    key_requirements,
}) => {
    return (
        <ModalSkeleton
            isVisible={visible}
            onClose={onClose}
            title={title || "Détails du contrôle"}
        >
            <ModalCardSkeleton title={"À réviser"} cond={!!key_requirements}>
                {key_requirements
                    ?.split("\n")
                    .filter((line) => line.trim().length > 0)
                    .map((line, index) => (
                        <BulletTextM key={index} text={line} />
                    ))}
            </ModalCardSkeleton>
        </ModalSkeleton>
    )
}
